import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { DATE_FORMAT } from "../../../constants/CommonConstants";
import moment from 'moment';
import  './OutputPaperGraph.css'

export const OutputPaperGraph = (props) => {

    let xAxisCategories = [];
    let outputPaperCountList = [];
    props.analysisDataList.forEach(data => {
        xAxisCategories.push(moment(data.date, DATE_FORMAT).format(props.intl.formatMessage({ id: "date_format2"})) + '(' + props.intl.formatMessage({ id: moment(data.date, DATE_FORMAT).format('ddd') }) + ')');
        outputPaperCountList.push(data.outputPaperCount);
    });

    return (
        <div className="output-paper-graph">
            <div className="output-paper-graph-title" >{props.intl.formatMessage({ id: "top_operator_subtitle_output_paper_result" })}</div>            
            <div className="zoom-button" style={{backgroundImage: `url(${props.zoomButtonIcon})`}} onClick={props.onFullScreenButtonClick} ></div>
            <HighchartsReact
                highcharts={Highcharts}
                constructorType={"chart"}
                containerProps={{ style: { height: "100%"} }}
                options={{
                    title: false,
                    chart: {
                        type: 'column'},
                    credits: false,
                    time:{useUTC: false},
                    xAxis: {
                        categories: xAxisCategories,
                        labels: {
                            style: {
                                "fontSize": '14px',
                                "color": '#77777B'
                            }
                        }
                    },
                    yAxis: [{
                        title: false,
                        min: 0,
                        labels: {
                            style: {
                                "fontSize": '14px',
                                "color": '#77777B'
                            }
                        }
                    }],
                    caption: {
                        text: props.intl.formatMessage({ id: "top_operator_subtitle_output_paper_count" }),
                        verticalAlign: 'top',
                        y: 5,
                        style: {
                            "color": '#77777B',
                            "fontSize": '14px'
                        }
                    },
                    legend: {
                        align: 'center',
                        verticalAlign: 'top',
                        y: -15,
                        backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || 'white',
                        borderWidth: 0,
                        itemStyle: {
                            "color": '#77777B',
                            "fontWeight": 'normal',
                            "fontSize": '14px'
                        },
                        symbolHeight: 10,
                        symbolWidth: 20,
                        squareSymbol: false,
                        symbolRadius: 0
                    },
                    tooltip: {
                        pointFormat: '{series.name}: {point.y}'
                    },
                    plotOptions: {
                        series: {
                            pointWidth: 25,
                            animation: {
                                duration: 1500,
                                easing: 'swing'
                            }
                        },
                    },
                    series: [{
                        name: props.intl.formatMessage({ id: "top_operator_paper_count" }),
                        data: outputPaperCountList,
                        color: '#8888f7',
                    }],
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false
                            },
                        }
                    },
                }}
            />
        </div>
    );
};
